var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LeftSideBar'),_c('RightSideBar'),_c('div',{staticClass:"page-wrapper"},[_c('Nav'),_c('router-view'),_c('my-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }